// @flow
import {
  LIST_PEOPLE,
  GET_FACE,
  SET_UPDATING,
  SET_SEARCH_QUERY,
  SET_SHOWMORE_STATUS,
  SET_EMPTY_ENROLMENTS,
  SET_FACE,
  SET_TAGS,
  SET_NAME,
  DELETE_PERSON,
  ADD_PERSON,
  SET_PEOPLE_FORM_ERROR,
  GET_ALL_TAGS
} from "../../global/actions/actionNames";

export type PeopleType = {
  uid: string,
  name: string,
  tags: string[]
};
export type PeopleDBStateType = {
  people?: PeopleType[],
  tagList?: string[],
  peopleFetchTime?: number,
  searchQuery?: string,
  showMore?: boolean,
  updating?: {
    fetchingPeople: *,
    searching: *,
    creating: *,
    editing: *
  },
  errors: {
    form: *
  }
};

const initialState: PeopleDBStateType = {
  people: [],
  tagList: [],
  peopleFetchTime: undefined,
  searchQuery: undefined,
  showMore: undefined,
  updating: {
    fetchingPeople: undefined,
    searching: undefined,
    creating: undefined,
    editing: undefined
  },
  errors: {
    form: undefined
  }
};

const peopleReducers = (
  state: PeopleDBStateType = initialState,
  actions: *
): * => {
  switch (actions.type) {
    case LIST_PEOPLE:
      if (actions.people !== undefined && actions.sendTime !== undefined) {
        if (
          actions.sendTime > state.peopleFetchTime ||
          state.peopleFetchTime === undefined
        ) {
          let myPeople = actions.isAppend ? [...state.people] : [];
          for (let i = 0; i < actions.people.length; i++) {
            let index = myPeople.findIndex(
              (x: *): Function => x.uid === actions.people[i].uid
            );
            if (index < 0) {
              myPeople.push(actions.people[i]);
            }
          }
          return {
            ...state,
            peopleFetchTime: actions.sendTime,
            people: myPeople
          };
        }
      }
      return {
        ...state,
        people: []
      };

    case ADD_PERSON:
      if (actions.person !== undefined) {
        let myPeople = [...state.people];
        let index = myPeople.findIndex((p) => p.uid === actions.person.uid);

        if (index > -1) {
          //replace if found
          myPeople[index] = { ...actions.person };
        } else {
          //add if not
          myPeople.unshift(actions.person);
        }
        return {
          ...state,
          people: myPeople
        };
      }
      return state;

    case GET_FACE:
      let myPeople = [...state.people];
      if (actions.face !== undefined && actions.uid !== undefined) {
        let index = myPeople.findIndex(
          (x: *): Function => x.uid === actions.uid
        );
        if (index > -1) {
          let person = { ...myPeople[index] };
          person.face = actions.face;
          myPeople[index] = person;
          return {
            ...state,
            people: myPeople
          };
        }
      }
      return {
        ...state,
        people: myPeople
      };

    case SET_UPDATING:
      if (actions.status !== undefined) {
        const updating = { ...state.updating };
        let adder;
        if (actions.status === true) {
          adder = 1;
        } else {
          adder = -1;
        }
        let objLocation = updating;
        if (actions.sender !== undefined) {
          if (objLocation[actions.sender] !== undefined) {
            objLocation[actions.sender] += adder;
            if (objLocation[actions.sender] === 0) {
              delete objLocation[actions.sender];
            }
          } else {
            objLocation[actions.sender] = adder;
          }
        }
        return {
          ...state,
          updating: updating
        };
      }
      return {
        ...state
      };

    case SET_SEARCH_QUERY:
      if (actions.query !== undefined) {
        return {
          ...state,
          searchQuery: actions.query
        };
      }
      return {
        ...state
      };

    case SET_SHOWMORE_STATUS:
      if (actions.status !== undefined) {
        return {
          ...state,
          showMore: actions.status
        };
      }
      return {
        ...state
      };

    case SET_EMPTY_ENROLMENTS:
      if (actions.personUid !== undefined) {
        let people = [...state.people];
        let index = people.findIndex(
          (x: *): Function => x.uid === actions.personUid
        );
        if (index > -1) {
          let person = { ...people[index] };
          person.enrolments = actions.setNull ? undefined : [];
          people[index] = person;

          return {
            ...state,
            people: people
          };
        }
      }
      return state;

    case SET_FACE:
      if (actions.enrolmentId !== undefined && actions.faceId !== undefined) {
        let people = [...state.people];
        let index = people.findIndex(
          (x: *): Function => x.uid === actions.personUid
        );
        if (index > -1) {
          let person = { ...people[index] };
          let enrolments = person.enrolments ? [...person.enrolments] : [];
          let index2 = enrolments.findIndex(
            (x: *): Function => x.enrolmentId === actions.enrolmentId
          );
          if (index2 > -1) {
            let enrolment = enrolments[index2];
            let faces = enrolment.faces ? [...enrolment.faces] : [];
            let index3 = faces.findIndex(
              (x: *): Function => x.imgToken === actions.faceId
            );
            if (index3 > -1) {
              faces[index3] = {
                imgToken: actions.faceId,
                imgUrl: actions.faceData
              };
            } else {
              faces.push({
                imgToken: actions.faceId,
                imgUrl: actions.faceData
              });
            }
            enrolment.faces = faces;
            enrolments[index2] = enrolment;
          } else {
            let face = { imgToken: actions.faceId, imgUrl: actions.faceData };
            enrolments.push({
              enrolmentId: actions.enrolmentId,
              faces: [face]
            });
          }
          person.enrolments = enrolments;
          people[index] = person;

          return {
            ...state,
            people: people
          };
        }
      }
      return state;

    case SET_TAGS:
      if (actions.personUid !== undefined && actions.tags !== undefined) {
        let people = [...state.people];
        let index = people.findIndex(
          (x: *): Function => x.uid === actions.personUid
        );
        if (index > -1) {
          let person = { ...people[index] };
          person.tags = [...actions.tags];
          people[index] = person;

          return {
            ...state,
            people: people
          };
        }
      }
      return state;

    case SET_NAME:
      if (actions.personUid !== undefined && actions.name !== undefined) {
        let people = [...state.people];
        let index = people.findIndex(
          (x: *): Function => x.uid === actions.personUid
        );
        if (index > -1) {
          let person = { ...people[index] };
          person.name = actions.name;
          people[index] = person;

          return {
            ...state,
            people: people
          };
        }
      }
      return state;

    case DELETE_PERSON:
      if (actions.uid !== undefined) {
        let people = [...state.people];
        let index = people.findIndex((x: *): Function => x.uid === actions.uid);
        people.splice(index, 1);
        return {
          ...state,
          people: people
        };
      }
      return state;

    case SET_PEOPLE_FORM_ERROR:
      if (actions.error !== undefined) {
        let errors = { ...state.errors };
        errors.form = actions.error;

        return {
          ...state,
          errors: errors
        };
      }
      return state;

    case GET_ALL_TAGS:
      if (actions.tags !== undefined) {
        return {
          ...state,
          tagList: actions.tags
        };
      } else {
        return state;
      }

      return state;
    default:
      return state;
  }
};
export default peopleReducers;
